<p-dialog appendTo="body" header="{{titleText}}" [(visible)]="show"
  [modal]="true" [closable]="false" [style]="{minWidth:'400px'}" [contentStyle]="{minHeight: '150px'}">
  <div innerHTML="{{message}}"></div>
  <div class="btn-container-dialog">
    <button id="okDelete" type="button" class="inm-button btn-padding" (click)="submitClick('save')">Ok</button>
    <button id="cancelDelete" type="button" class="inm-button btn-padding" (click)="submitClick('cancel')">Cancel</button>
  </div>
</p-dialog>
